import React from 'react';
import { Box } from '@chakra-ui/react';

const CustomProgress = ({ value, max }: { value: number; max: number }) => {
	const progress = (value / max) * 100;

	return (
		<Box bg="#E4E4EB" h="8px" borderRadius="full" position="relative" w="100%" overflow="hidden">
			<Box bg="#3568D4" h="100%" transition="width 0.3s" width={`${progress}%`}></Box>
		</Box>
	);
};

export default CustomProgress;
